"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_DramaticEndingsEffectHandler = exports.Passive_DramaticEndingsEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_DramaticEndingsEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Passive_DramaticEndings;
        this.__typeName = "Passive_DramaticEndings";
        this.name = "Dramatic Endings";
        this.harmful = false;
    }
}
exports.Passive_DramaticEndingsEffectArgs = Passive_DramaticEndingsEffectArgs;
let Passive_DramaticEndingsEffectHandler = class Passive_DramaticEndingsEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerIds = [
            container.registerEventHandler(state.creatorId, EventType_1.EventType.AllyKilled, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStarted", {})),
            container.registerEventHandler(state.creatorId, EventType_1.EventType.AllyResurrected, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStarted", {})),
            container.registerEventHandler(state.creatorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStarted", {})),
        ];
    }
    remove(sequence, container, state) {
        state.meta.eventHandlerIds.forEach(id => container.cancelEventHandler(id));
    }
};
Passive_DramaticEndingsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_DramaticEndings)
], Passive_DramaticEndingsEffectHandler);
exports.Passive_DramaticEndingsEffectHandler = Passive_DramaticEndingsEffectHandler;
